// extracted by mini-css-extract-plugin
module.exports = {"accepted":"ConsentStatus_accepted__1IOJQ","declined":"ConsentStatus_declined__1LgmD","withdrawn":"ConsentStatus_withdrawn__1tL2a"};